import { getMessages } from '../../../../../../../store/constants';
import { CLASS_CARD_DETAILS } from '../../../constants';

export const CLASS_CARD_DETAILS_RELATED = CLASS_CARD_DETAILS + '-related';
export const CARD_SECTION_RELATED = getMessages().getText('card_form_section_related');
export const CARD_RELATED_ADD = getMessages().getText('card_form_add_related_cards_label');
